import React from 'react';
import PropTypes from 'prop-types';
import styles from './BillingContactInfo.module.scss';

const BillingContactInfo = ({
  billingContactEmail,
  billingContactName,
  billingContactInfoNeeded,
  setBillingContactInfoNeededOnChange,
  setField,
  validateField,
}) => {
  return (
    <form>
      <fieldset>
        <label className={styles.label} htmlFor="same_as_contact">
          <input
            type="radio"
            id="same_as_contact"
            name="billing_contact_info_needed"
            onChange={setBillingContactInfoNeededOnChange}
            checked={!billingContactInfoNeeded}
            value="false"
          />
          Same as contact information
        </label>
        <label className={styles.label} htmlFor="different_billing_contact">
          <input
            type="radio"
            id="different_billing_contact"
            name="billing_contact_info_needed"
            onChange={setBillingContactInfoNeededOnChange}
            checked={billingContactInfoNeeded}
            value="true"
          />
          Use a different billing contact
        </label>
      </fieldset>
      {billingContactInfoNeeded
      && (
        <div>
          <div>
            <label className={styles.label__required} htmlFor="id_billing_contact_name">
              <div className={styles.label__name}>Billing contact name</div>
              <span className={styles.required}>*</span>
              <input
                type="text"
                name="billingContactName"
                id="id_billing_contact_name"
                className={`${(billingContactName.touched && !billingContactName.valid) ? styles.error__highlight : ''}`}
                onBlur={validateField}
                onChange={setField}
                value={billingContactName.value}
              />
              {(billingContactName.touched && !billingContactName.valid)
                && <p className={styles.error}>{billingContactName.errors[0]}</p>}
            </label>
          </div>
          <div>
            <label className={styles.label__required} htmlFor="id_billing_contact_email">
              <div className={styles.label__name}>Email address for billing messages</div>
              <span className={styles.required}>*</span>
              <input
                type="text"
                name="billingContactEmail"
                id="id_billing_contact_email"
                className={`${(billingContactEmail.touched && !billingContactEmail.valid) ? styles.error__highlight : ''}`}
                onBlur={validateField}
                onChange={setField}
                value={billingContactEmail.value}
              />
              {(billingContactEmail.touched && !billingContactEmail.valid)
                && <p className={styles.error}>{billingContactEmail.errors[0]}</p>}
            </label>
          </div>
        </div>
      )}
    </form>
  );
};

BillingContactInfo.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  billingContactName: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  billingContactEmail: PropTypes.object.isRequired,
  billingContactInfoNeeded: PropTypes.bool.isRequired,
  setBillingContactInfoNeededOnChange: PropTypes.func.isRequired,
  setField: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
};

export default BillingContactInfo;
